import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useFetchEventById } from "../../../hooks/all.hooks";
import DetailsBackground from "../../../components/NewsDetailsBg";

const EventDetail: React.FC = () => {
  const navigate = useNavigate();
  const { id } = useParams<{ id: string }>();

  const {
    data: eventDetail,
    isLoading,
    isError,
  } = useFetchEventById(id as string);

  const handleReadMore = (relatedId: string) => {
    navigate(`/event/${relatedId}`);
  };
  useEffect(() => {
    if (isError) {
      navigate("/not-found");
    }
  }, [isError, navigate]);

  if (isLoading) return <p>Loading...</p>;

  if (isError) {
    // Optional: You can keep a fallback UI here temporarily before redirecting
    return null;
  }

  return (
    <>
      <DetailsBackground title={eventDetail?.title || "more details"} />
      <div className="max-w-4xl mx-auto p-6">
        {eventDetail?.imageUrl && (
          <img
            src={eventDetail?.imageUrl}
            alt={eventDetail?.title}
            className="w-full h-auto mb-6"
          />
        )}
        <div
          className="text-xs news-content"
          dangerouslySetInnerHTML={{ __html: eventDetail?.content }}
        />

        {/* Related Posts Section */}
        <div className="mt-12">
          <h2 className="text-2xl font-semibold mb-4">Related Posts</h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
            {eventDetail.relatedPosts.map((related: any) => (
              <div
                key={related._id}
                className="flex items-center space-x-4 cursor-pointer"
                onClick={() => handleReadMore(related._id)}
              >
                <img
                  src={related.imageUrl}
                  alt={related.title}
                  className="w-24 h-24 object-contain rounded-md"
                />
                <div>
                  <h3 className="text-xs font-semibold">{related.title}</h3>
                  <div className="flex gap-2">
                    <p className="text-xxs text-foreground">
                      {new Date(related.startDate).toLocaleDateString()}
                    </p>
                    <p className="text-xxs text-foreground">-</p>
                    <p className="text-xxs text-foreground">
                      {new Date(related.endDate).toLocaleDateString()}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default EventDetail;
